module.exports = __webpack_public_path__ + "media/images/editorial_board_icons/eb_miller_sm-d3c95f5ab95ffe4a6985ab9772d33f53.png";